export default __webpack_public_path__ + "static/media/portugalia.fe2980ee.jpg";